import React, {useEffect, useState} from 'react';
import Attention from "../../components/attention/Attention";
import TitleSubtitle from "../../components/titlesubtitle/TitleSubtitle";
import {useTranslation} from "react-i18next";
import "./ServicesPage.css"
import PopupLogin from "../../components/popuplogin/PopupLogin";
import ServicesHome from "../../components/accordion/ServicesHome";
import {useLocation, useNavigate} from "react-router-dom";


const ServicesPage = () => {
    const { t } = useTranslation();
    const [hasJWTToken, setHasJWTToken] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const togglePopup = () => {
        setIsPopupOpen(!isPopupOpen);
    };

    const checkTokenExpiration = () => {
        const expirationTime = localStorage.getItem("tokenExpiredTime");
        const currentTime = new Date();


        if (expirationTime) {
            const expirationDate = new Date(expirationTime);
            if (currentTime > expirationDate) {
                localStorage.removeItem("jwtToken");
                localStorage.removeItem("tokenExpiredTime");
                return true; // Token was expired and removed
            }
        }
        return false; // Token not expired or not found
    };

    useEffect(() => {
        if (checkTokenExpiration()) {
            localStorage.removeItem("jwtToken");
            navigate('/');
            setHasJWTToken(false);
        }
    }, [location, navigate]);

    useEffect(() => {
        setHasJWTToken(!!localStorage.getItem('jwtToken'));
    }, [hasJWTToken]);

    return (
        <div className={"service-page-container"}>


            {!hasJWTToken ? (
                <Attention attentionClick={togglePopup}  text={t('განაცხადის ატვირთვისთვის გაიარეთ ავტორიზაცია!')}/>
            ) : (
                <div style={{marginTop: 80}}></div>
            )}

            <TitleSubtitle titleText={(
                <>
                    {t("ისარგებლე ჩვენი")} <br/>
                    {t("ციფრული სერვისებით")}
                </>
            )} subtitleText={t("აირჩიე სასურველი სერვისი")}/>
            <div style={{marginBottom: 50}}></div>
            <ServicesHome/>
            {isPopupOpen && <PopupLogin isOpened={isPopupOpen} onClose={togglePopup}/>}

        </div>

    );
}

export default ServicesPage;
